import classNames from 'classnames';
import React from 'react';

import { Image } from '@/shared/ui';

import './loader.scss';

interface Props {
  centered?: boolean;
  color?: 'black' | 'white';
}

export const Loader = React.memo<Props>(({ centered = true, color = 'black' }) => {
  return (
    <div
      className={classNames('loader', {
        centered,
        [color]: color,
      })}
    >
      <Image src="/images/loader.svg" alt="loader" width={50} height={50} />
    </div>
  );
});
